/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import { FC } from 'react'
import { navigateToModal } from '../../../../../../../jsFunctions'
// import { Client } from '../../../../parent-management/clients-list/core/_models'

type Props = {
  parent: {
    avatar?: string
    label?: string
    id?: string
  },
  navigation: {
    id?: string
    path?: string
  }
}

const ParentInfoCell: FC<Props> = ({ parent, navigation }) => {
  const label = parent?.label || 'N/A'
  const canNavigate = Boolean(navigation.path && navigation.id)

  return (
    <div
      className={clsx('d-flex align-items-center', {'cursor-pointer': canNavigate})}
      onClick={() => {
        if (canNavigate) {
          navigateToModal(navigation.path, navigation.id)
        }
      }}
    >
      {/* begin:: Avatar */}
      <div className='symbol symbol-oval symbol-30px overflow-hidden me-3'>
        <a href='#'>
          {parent?.avatar ? (
            <div className='symbol-label'>
              <img src={parent.avatar} alt={label} className='w-100' />
            </div>
          ) : (
            <div className='symbol-label fs-3 bg-light-secondary text-gray-600'>
              {label[0]}
            </div>
          )}
        </a>
      </div>
      <div className='d-flex flex-column'>
        <div className={clsx('text-gray-500 fw-normal', {'text-hover-primary': canNavigate})}>
          {label}
        </div>
      </div>
    </div>
  )
}

export { ParentInfoCell }

